export const jobsCacheKeys = {
  post_job: () => ['post_job'] as const,
  fetch_jobs: queryParams => ['jobs', queryParams] as const,
  fetch_jobs_invalidate: () => ['jobs'] as const,
  merge_jobs: () => ['merge_jobs'] as const,
  put_job: () => ['put_job'] as const
}
